import { render, staticRenderFns } from "./TargetPrize.vue?vue&type=template&id=2a34c80c&scoped=true&"
import script from "./TargetPrize.vue?vue&type=script&lang=js&"
export * from "./TargetPrize.vue?vue&type=script&lang=js&"
import style0 from "./TargetPrize.vue?vue&type=style&index=0&id=2a34c80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a34c80c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a34c80c')) {
      api.createRecord('2a34c80c', component.options)
    } else {
      api.reload('2a34c80c', component.options)
    }
    module.hot.accept("./TargetPrize.vue?vue&type=template&id=2a34c80c&scoped=true&", function () {
      api.rerender('2a34c80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Barcode/components/TargetPrize.vue"
export default component.exports